<template>
  <Modal
    :closable="false"
    v-model="show"
    footer-hide
    >
    <div v-if="subject">
      <Row>
        <Col span="24">
          <p style="font-size: 16px; font-weight: bold; padding: 0 0 12px; white-space: pre-line">
            {{ subject.journal.text }}
          </p>
          <p style="font-size: 13px; padding: 0 0 24px;">この原稿を採用します。よろしいですか？</p>
        </Col>
      </Row>
      <Row>
        <Col span="6">
          <Button type="text" @click="show = false">キャンセル</Button>
        </Col>
        <Col span="7" style="padding-right: 4px">
          <Select
            v-model="selectedMaterialCategoryId"
            :disabled="materialCategories.length == 0"
            placeholder="素材項目"
            @on-change="setDefaultMaterialGroupId"
            >
            <Option
              v-for="materialCategory in materialCategories"
              :key="materialCategory.id"
              :value="materialCategory.id"
              >{{ materialCategory.name }}
            </Option>
          </Select>
        </Col>
        <Col span="7" style="padding-right: 4px">
          <Select
            v-model="selectedMaterialGroupId"
            :disabled="!selectedMaterialCategory"
            placeholder="素材部品"
            >
            <template
              v-if="selectedMaterialCategory"
              >
              <Option
                v-for="materialGroup in selectedMaterialCategory.material_groups.filter(i => i.material_type.capacity && i.material_type.acceptable)"
                :key="materialGroup.id"
                :value="materialGroup.id"
                >
                {{ materialGroup.material_type.name }}
              </Option>
            </template>
          </Select>
        </Col>
        <Col span="4">
          <Button
            type="primary"
            :disabled="(!selectedMaterialGroupId || !selectedMaterialCategoryId) && subject.journal.text.length != subject.journal.text.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]|[^\uD800-\uDFFF]/g).length"
            long
            @click="acceptSubject()"
          >
            採用する
          </Button>
        </Col>
      </Row>
    </div>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      show: false,
      subject: null,
      selectedMaterialCategoryId: null,
      selectedMaterialGroupId: null,
    }
  },
  watch: {
    target(val) {
      if (val) {
        this.show = true
        this.subject = val
        this.selectedMaterialCategoryId = this.getDefaultMaterialCategoryId()
        this.selectedMaterialGroupId = this.getDefaultMaterialGroupId(this.selectedMaterialCategoryId)
      } else {
        this.show = false
        this.subject = null
      }
    },
    show(val) {
      if (!val) {
        this.unsetTarget()
      }
    },
  },
  computed: {
    ...mapGetters([
      'materialCategories',
    ]),
    ...mapGetters({
      target: 'dashboard/subjectAcceptModalTarget'
    }),
    page() {
      return this.$route.params
    },
    selectedMaterialCategory() {
      return this.materialCategories.find(i => i.id == this.selectedMaterialCategoryId)
    }
  },
  methods: {
    ...mapActions({
      unsetTarget: 'dashboard/unsetSubjectAcceptModalTarget',
    }),
    getDefaultMaterialCategoryId() {
      const candidate = this.materialCategories
        .find(i => i.meta.categories && i.meta.categories.includes(this.subject.topic.meta.category))
      return candidate ? candidate.id : this.materialCategories[0].id
    },
    getDefaultMaterialGroupId(materialCategoryId) {
      const materialCategory = this.materialCategories
        .find(i => i.id == materialCategoryId)

      const materialGroup = materialCategory.material_groups
        .find(i => i.material_type.acceptable)

      return materialGroup.id
    },
    setDefaultMaterialGroupId() {
      this.selectedMaterialGroupId = this.getDefaultMaterialGroupId(this.selectedMaterialCategoryId)
    },
    async acceptSubject() {
      await this.$store.dispatch('acceptSubject', {
        ...this.page,
        subjectId: this.subject.id,
        materialGroupId: this.selectedMaterialGroupId,
      })
      this.show = false
    }
  }
}
</script>
